import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Mount only on the fixed handful of routes Offline Public Frontend V1
 * makes available offline (Home, About, legal pages, FAQ): asks the
 * service worker to proactively cache this page's shell + the same-origin
 * assets it just loaded, mirroring StaffNotepad.jsx's CACHE_NOTEPAD_SHELL
 * trigger exactly. The service worker independently re-validates every
 * path/asset against its own allowlist (STATIC_PUBLIC_PATHS /
 * isAllowedPublicShellAsset): this component cannot widen what gets
 * cached beyond what service-worker.js already permits.
 */
export default function CachePublicShell() {
  const location = useLocation();
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.ready.then((registration) => {
      const assets = [
        ...Array.from(document.scripts).map((script) => script.src),
        ...Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map((link) => link.href),
        ...performance.getEntriesByType("resource").map((entry) => entry.name),
      ].filter(Boolean);
      registration.active?.postMessage({
        type: "CACHE_PUBLIC_SHELL",
        assets,
        path: location.pathname,
      });
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}
